export const REGISTRATION_PENDING = 'REGISTRATION_PENDING'
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS'
export const REGISTRATION_FAIL = 'REGISTRATION_FAIL'
export const CLEAR_REGISTRATION_ERROR = 'CLEAR_REGISTRATION_ERROR'

export const LOGIN_PENDING = 'LOGIN_PENDING'
export const LOGIN_PENDING_DETAILS = 'LOGIN_PENDING_DETAILS'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'
export const CLEAR_SIGN_IN_ERROR = 'CLEAR_SIGN_IN_ERROR'

export const PROFILE_FETCH_PENDING = 'PROFILE_FETCH_PENDING'
export const PROFILE_FETCH_SUCCESS = 'PROFILE_FETCH_SUCCESS'
export const PROFILE_FETCH_FAIL = 'PROFILE_FETCH_FAIL'
export const PROFILE_UPDATE_PENDING = 'PROFILE_UPDATE_PENDING'
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS'
export const PROFILE_UPDATE_FAIL = 'PROFILE_UPDATE_FAIL'
export const PHOTO_UPDATE_PENDING = 'PHOTO_UPDATE_PENDING'
export const PHOTO_UPDATE_SUCCESS = 'PHOTO_UPDATE_SUCCESS'
export const PHOTO_UPDATE_FAIL = 'PHOTO_UPDATE_FAIL'
export const PASSWORD_UPDATE_PENDING = 'PASSWORD_UPDATE_PENDING'
export const PASSWORD_UPDATE_SUCCESS = 'PASSWORD_UPDATE_SUCCESS'
export const PASSWORD_UPDATE_FAIL = 'PASSWORD_UPDATE_FAIL'

export const TWITTER_LOGIN_PENDING = 'TWITTER_LOGIN_PENDING'
export const TWITTER_LOGIN_SUCCESS = 'TWITTER_LOGIN_SUCCESS'
export const TWITTER_LOGIN_FAIL = 'TWITTER_LOGIN_FAIL'
export const CLEAR_TWITTER_ERROR = 'CLEAR_TWITTER_ERROR'

export const FACEBOOK_LOGIN_PENDING = 'FACEBOOK_LOGIN_PENDING'
export const FACEBOOK_LOGIN_SUCCESS = 'FACEBOOK_LOGIN_SUCCESS'
export const FACEBOOK_LOGIN_ERROR = 'FACEBOOK_LOGIN_ERROR'
export const FACEBOOK_LOGIN_FAIL = 'FACEBOOK_LOGIN_FAIL'
export const CLEAR_FACEBOOK_ERROR = 'CLEAR_FACEBOOK_ERROR'

export const GOOGLE_LOGIN_PENDING = 'GOOGLE_LOGIN_PENDING'
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS'
export const GOOGLE_LOGIN_FAIL = 'GOOGLE_LOGIN_FAIL'
export const CLEAR_GOOGLE_ERROR = 'CLEAR_GOOGLE_ERROR'

export const UPDATE_PASSWORD_PENDING = 'UPDATE_PASSWORD_PENDING'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAIL = 'UPDATE_PASSWORD_FAIL'
export const CLEAR_PASSWORD_ERROR = 'CLEAR_PASSWORD_ERROR'

export const CLEAR_PROFILE_ERROR = 'CLEAR_PROFILE_ERROR'

export const INIT_APP_PARAMS = 'INIT_APP_PARAMS'
export const SEND_WINDOW_INFO = 'SEND_WINDOW_INFO'
export const BACK_POST_MESSAGE = 'BACK_POST_MESSAGE'
export const APP_PARAMS_INITIALIZED = 'SET_APP_PARAMS'
export const APP_PARAMS_ERROR = 'APP_PARAMS_ERROR'

export const CHANGE_AUTH_STATE = 'CHANGE_AUTH_STATE'
export const USER_AUTHENTICATED = 'USER_AUTHENTICATED'

export const INIT_AUTH_FLOW_PARAMS = 'INIT_AUTH_FLOW_PARAMS'
export const AUTH_FLOW_PARAMS_INITIALIZED = 'AUTH_FLOW_PARAMS_INITIALIZED'

export const INIT_PAYMENT_GATEWAY = 'INIT_PAYMENT_GATEWAY'
export const INIT_PAYMENT_GATEWAY_FAIL = 'INIT_PAYMENT_GATEWAY_FAIL'
export const INIT_PAYMENT_GATEWAY_SUCCESS = 'INIT_PAYMENT_GATEWAY_SUCCESS'

export const INIT_BRAINTREE_CLIENT = 'INIT_BRAINTREE_CLIENT'
export const INIT_BRAINTREE_CLIENT_FAIL = 'INIT_BRAINTREE_CLIENT_FAIL'
export const INIT_BRAINTREE_CLIENT_SUCCESS = 'INIT_BRAINTREE_CLIENT_SUCCESS'

export const INIT_BRAINTREE_3DSECURE = 'INIT_BRAINTREE_3DSECURE'
export const INIT_BRAINTREE_3DSECURE_FAIL = 'INIT_BRAINTREE_3DSECURE_FAIL'
export const INIT_BRAINTREE_3DSECURE_SUCCESS = 'INIT_BRAINTREE_3DSECURE_SUCCESS'

export const INIT_BRAINTREE_HOSTEDFIELDS = 'INIT_BRAINTREE_HOSTEDFIELDS'
export const INIT_BRAINTREE_HOSTEDFIELDS_FAIL = 'INIT_BRAINTREE_HOSTEDFIELDS_FAIL'
export const INIT_BRAINTREE_HOSTEDFIELDS_SUCCESS = 'INIT_BRAINTREE_HOSTEDFIELDS_SUCCESS'

export const INIT_SESSION_CALL = 'INIT_SESSION_CALL'
export const INIT_SESSION_CALL_FAIL = 'INIT_SESSION_CALL_FAIL'
export const INIT_SESSION_CALL_SUCCESS = 'INIT_SESSION_CALL_SUCCESS'

export const INIT_ADD_FREE_PAYMENT = 'INIT_ADD_FREE_PAYMENT'
export const INIT_ADD_FREE_PAYMENT_FAIL = 'INIT_ADD_FREE_PAYMENT_FAIL'
export const INIT_ADD_FREE_PAYMENT_SUCCESS = 'INIT_ADD_FREE_PAYMENT_SUCCESS'

export const SEND_POST_MESSAGE = 'SEND_POST_MESSAGE'
export const SEND_POST_MESSAGE_FAIL = 'SEND_POST_MESSAGE_FAIL'
export const SEND_POST_MESSAGE_SUCCESS = 'SEND_POST_MESSAGE_SUCCESS'



// WEBPACK FOOTER //
// ./src/actions/index.js